import axios, { AxiosRequestConfig } from 'axios';
import { BaseUtil } from '@xl/js-utils';
import qs from 'qs';
import host from '@/config/host';
import { Toast } from 'vant';
import { AppModule } from '@/store/modules/app';
import { jumpLogin } from '@/common/jump-login';

const phpTokenFailCode = 10001;

// 创建axios实例
const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? '/index.php'
      : `${host.API_HOST}/index.php`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  transformRequest: [
    function(data, headers) {
      if (!data) {
        return;
      }
      if (headers['Content-Type'] == 'multipart/form-data') {
        return data;
      }
      return qs.stringify(data);
    },
  ],
});

// 添加请求拦截器
instance.interceptors.request.use(
  function(config) {
    const { driver_md5, revision, token } = AppModule.urlParams || {};
    const commonParameters = {
      driver_md5,
      token: token || AppModule.token || '',
      trace_id: BaseUtil.createSu(),
      revision,
    };
    config.params = {
      ...config.params,
      ...commonParameters,
    };
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    const config: AxiosRequestConfig & {
      showError?: boolean;
    } = response.config;
    // dappweb接口需要登录的状态码
    const code = res.ret;
    if (code === phpTokenFailCode) {
    // app内容 h5外 微信小程序
      Toast({ message: '登录失效，请重新登录' });
      setTimeout(() => {
        jumpLogin();
      }, 2000);
    }
    // 业务异常状态码
    if (res && res.ret != null && res.ret != 0) {
      const message = res.msg || '系统错误';
      if (config.showError !== false) {
        // dappweb接口需要登录的状态码
        if (code !== phpTokenFailCode) {
          Toast(message);
        }
      }
      // 业务异常时，reject 与请求失败一样的结构体
      const error: Error & {
        response?: any;
      } = new Error(message);
      error.response = response;
      return Promise.reject(error);
    }
    return Promise.resolve(res);
  },
  (error) => {
    const config = (error.response || {}).config || {};
    if (config.showError !== false) {
      Toast(error.message || '系统错误');
    }
    return Promise.reject(error);
  },
);

export default instance;
